import { NgModule } from '@angular/core';
import { CheckoutRootModule, CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import { CmsConfig, RoutingConfig, provideConfig } from '@spartacus/core';
import { CheckoutModule } from '../legacy-checkout/checkout.module';

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule, CheckoutModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('../legacy-checkout/checkout.module').then((m) => m.CheckoutModule),
        },
      },
    }),
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          checkoutLogin: { paths: ['checkout-login'], authFlow: true },
          checkout: { paths: ['checkout'] },
          checkoutDeliveryAddress: { paths: ['checkout/shipping-address'] },
          checkoutDeliveryMode: { paths: ['checkout/delivery-mode'] },
          checkoutPaymentDetails: { paths: ['checkout/payment-details'] },
          checkoutReviewOrder: { paths: ['checkout/review-order'] },
        },
      },
    }),
  ],
})
export class CheckoutFeatureModule {}
